import React, { Component } from "react";
import "./AndroidBanner.css";

const BOOKLY_LOGO_SRC = "/bookly-app-qr.png";
const QR_CODE_IMAGE_SRC = "/bookly-app-qr.jpeg";
const ANDROID_APP_URL = "https://bookly.com.bd/bookly.apk";

const destinationImages = {
  dhaka:
    "https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&w=320&q=85",
  coxsBazar:
    "https://images.unsplash.com/photo-1500375592092-40eb2168fd21?auto=format&fit=crop&w=320&q=85",
  sajek:
    "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=320&q=85",
};

class AndroidBanner extends Component {
  renderBooklyLogo = (variant = "main") => (
    <img
      className={`android-banner-logo android-banner-logo--${variant}`}
      src={this.props.logoSrc || BOOKLY_LOGO_SRC}
      alt="Bookly — book smart. travel easy"
    />
  );

  renderPinIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  );

  renderAndroidIcon = () => (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <g fill="currentColor">
        <path d="M19.1 12.4 14.7 5.1a1.5 1.5 0 0 1 2.6-1.5l4.7 7.8a25 25 0 0 1 20 0l4.7-7.8a1.5 1.5 0 0 1 2.6 1.5l-4.4 7.3A20.5 20.5 0 0 1 53 28H11a20.5 20.5 0 0 1 8.1-15.6Z" />
        <path d="M11 31h42v18a5 5 0 0 1-5 5h-3v5.5a3.5 3.5 0 0 1-7 0V54H26v5.5a3.5 3.5 0 0 1-7 0V54h-3a5 5 0 0 1-5-5V31Z" />
      </g>
      <circle cx="22" cy="20" r="2" fill="#fff" />
      <circle cx="42" cy="20" r="2" fill="#fff" />
    </svg>
  );

  renderPhoneCategoryIcon = (type) => {
    const icons = {
      room: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 19V8m18 11V8M3 14h18M6 14v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3M3 19v2m18-2v2" />
        </svg>
      ),
      apartment: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17M2 21h20M8 7h2m-2 4h2m-2 4h2m4-8h-1m1 4h-1m1 4h-1M18 21v-7h2v7" />
        </svg>
      ),
      hotel: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 21V5l9-3 9 3v16M1 21h22M7 8h2m6 0h2M7 12h2m6 0h2M7 16h2m6 0h2M10 21v-3h4v3" />
        </svg>
      ),
      resort: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 21h18M12 21V9m0 0-5-5m5 5 5-5M4 11c2-2 4-2 6 0m4 0c2-2 4-2 6 0M6 7l-2-2m14 2 2-2" />
        </svg>
      ),
    };

    return icons[type] || null;
  };

  renderPhoneNavIcon = (type) => {
    const icons = {
      home: <path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V10Z" />,
      booking: <path d="M6 3h12a2 2 0 0 1 2 2v16l-8-4-8 4V5a2 2 0 0 1 2-2Zm3 5h6m-6 4h6" />,
      saved: <path d="M20.8 8.6c0 5.2-8.8 10.3-8.8 10.3S3.2 13.8 3.2 8.6A4.6 4.6 0 0 1 12 6.4a4.6 4.6 0 0 1 8.8 2.2Z" />,
      profile: (
        <>
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21a8 8 0 0 1 16 0" />
        </>
      ),
    };

    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        {icons[type]}
      </svg>
    );
  };

  renderPhoneMockup = () => (
    <div className="android-banner-phone" aria-label="Preview of the Bookly mobile app">
      <span className="android-banner-phone-side-button" />
      <div className="android-banner-phone-screen">
        <div className="android-banner-phone-status">
          <span className="android-banner-phone-time">9:41</span>
          <span className="android-banner-status-icons" aria-hidden="true">
            <svg viewBox="0 0 42 14" role="presentation">
              <path className="status-signal" d="M2 12V9.5M6 12V7.5M10 12V5M14 12V2.5" />
              <path className="status-wifi" d="M20 5.2c3.2-2.8 7.8-2.8 11 0M22.8 8c1.7-1.5 3.8-1.5 5.5 0M25.1 10.5h.8" />
              <rect className="status-battery-outline" x="34" y="3" width="6" height="8" rx="1.2" />
              <path className="status-battery-fill" d="M36 5h2v4h-2z" />
            </svg>
          </span>
        </div>

        <div className="android-banner-phone-content">
          <div className="android-banner-phone-main">
            {this.renderBooklyLogo("phone")}

            <div className="android-banner-phone-search">
              {this.renderPinIcon()}
              <span>Where do you want to stay?</span>
            </div>

            <div className="android-banner-phone-categories">
              {[
                ["room", "Rooms"],
                ["apartment", "Apartments"],
                ["hotel", "Hotels"],
                ["resort", "Resorts"],
              ].map(([type, label]) => (
                <div className="android-banner-phone-category" key={type}>
                  <span>{this.renderPhoneCategoryIcon(type)}</span>
                  <small>{label}</small>
                </div>
              ))}
            </div>

            <div className="android-banner-phone-section-heading">
              <strong>Popular Destinations</strong>
              <span>See All</span>
            </div>

            <div className="android-banner-phone-destinations">
              <div className="android-banner-phone-destination">
                <img src={destinationImages.dhaka} alt="Dhaka destination" loading="lazy" />
                <small>Dhaka</small>
              </div>
              <div className="android-banner-phone-destination">
                <img src={destinationImages.coxsBazar} alt="Cox's Bazar beach" loading="lazy" />
                <small>Cox's Bazar</small>
              </div>
              <div className="android-banner-phone-destination">
                <img src={destinationImages.sajek} alt="Sajek hill destination" loading="lazy" />
                <small>Sajek</small>
              </div>
            </div>
          </div>

          <div className="android-banner-phone-bottom-nav">
            {[
              ["home", "Home"],
              ["booking", "Bookings"],
              ["saved", "Saved"],
              ["profile", "Profile"],
            ].map(([type, label], index) => (
              <div className={index === 0 ? "is-active" : ""} key={type}>
                {this.renderPhoneNavIcon(type)}
                <small>{label}</small>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  renderGooglePlayBadge = () => (
    <a
      className="android-banner-play-badge"
      href={ANDROID_APP_URL}
      aria-label="Download the Bookly Android app"
    >
      <span className="android-banner-play-icon" aria-hidden="true">
        <svg viewBox="0 0 48 48">
          <path d="M7 5.5c-.7.7-1.1 1.8-1.1 3.3v30.4c0 1.5.4 2.6 1.1 3.3L25.5 24 7 5.5Z" fill="#26D367" />
          <path d="m25.5 24 7.8-7.8L11.4 5.8C9.7 4.9 8.2 5 7 5.5L25.5 24Z" fill="#20B8FF" />
          <path d="m25.5 24 7.8 7.8L11.4 42.2c-1.7.9-3.2.8-4.4.3L25.5 24Z" fill="#FFD33F" />
          <path d="m33.3 16.2 7.9 4.3c2.6 1.4 2.6 3.6 0 5l-7.9 4.3L25.5 24l7.8-7.8Z" fill="#F34D56" />
        </svg>
      </span>
      <span className="android-banner-play-copy">
        <small>GET IT ON</small>
        <strong>Google Play</strong>
      </span>
    </a>
  );

  render() {
    const qrCodeSrc = this.props.qrCodeSrc || QR_CODE_IMAGE_SRC;

    return (
      <section className="android-banner-section" aria-labelledby="android-banner-title">
        <div className="android-banner-shell">
          <div className="android-banner-copy">
            <a className="android-banner-brand-link" href="/" aria-label="Bookly home">
              {this.renderBooklyLogo("main")}
            </a>

            <h1 id="android-banner-title">
              <span className="android-banner-heading-first">Download Our</span>
              <span className="android-banner-heading-second">Android App</span>
            </h1>
            <p>Find and book rooms, apartments, hotels and resorts easily with Bookly.</p>
          </div>

          <div className="android-banner-download">
            <a
              className="android-banner-qr-card"
              href={ANDROID_APP_URL}
              aria-label="Download the Bookly Android app using the QR code"
            >
              <div className="android-banner-qr-frame">
                <span className="android-banner-qr-corner top-left" />
                <span className="android-banner-qr-corner top-right" />
                <span className="android-banner-qr-corner bottom-left" />
                <span className="android-banner-qr-corner bottom-right" />
                <img
                  className="android-banner-qr-image"
                  src={qrCodeSrc}
                  alt="Bookly Android app download QR code"
                />
              </div>
              <strong>Scan QR Code</strong>
              <span>to download the app</span>
            </a>

            {this.renderGooglePlayBadge()}
          </div>

          <div className="android-banner-visual" aria-hidden="true">
            <div className="android-banner-visual-orb android-banner-visual-orb--large" />
            <div className="android-banner-visual-orb android-banner-visual-orb--small" />

            <svg className="android-banner-dotted-arrow" viewBox="0 0 150 110" fill="none">
              <path d="M137 14C112 1 83 10 76 34c-4 14 8 23 17 14 8-8-1-18-9-10-13 14-18 29-30 37-11 7-23 4-31-4" stroke="currentColor" strokeWidth="2" strokeDasharray="5 6" strokeLinecap="round" />
              <path d="m29 61-7 11 13 2" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            {this.renderPhoneMockup()}

            <div className="android-banner-android-bubble">
              {this.renderAndroidIcon()}
            </div>
            <div className="android-banner-accent-lines">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AndroidBanner;
